import type { ReactNode } from 'react'
import { Link } from '@inertiajs/react'
import { root_path } from '@/lib/routes'

interface GuestLayoutProps {
  children: ReactNode
}

export function GuestLayout({ children }: GuestLayoutProps) {
  return (
    <div className="bg-background flex min-h-screen flex-col justify-center px-4 py-8 sm:px-6 sm:py-12 lg:px-8">
      <div className="mx-auto w-full max-w-md">
        <Link href={root_path()} className="flex justify-center">
          <h2 className="text-primary text-2xl font-bold sm:text-3xl">
            Init Habit
          </h2>
        </Link>
      </div>
      <div className="mx-auto mt-6 w-full max-w-md sm:mt-8">
        <div className="bg-card border-border rounded-xl border px-4 py-6 shadow-sm sm:rounded-2xl sm:px-10 sm:py-8 sm:shadow">
          {children}
        </div>
      </div>
    </div>
  )
}
